import { ref, reactive, computed, onMounted } from 'vue'
import { defineStore } from 'pinia'

// import Ajax from '@utils/ajax'

import Customer from '@model/customer'
import { useSettings } from '@store/settings'

export const useCustomer = defineStore('customer', () => {
    const $settings = useSettings()
    // const isLoading = ref(false)

    // Fetch all customers
    const customers = ref([])
    const getCustomers = computed(() => customers.value)
    const fetchCustomers = async () => {
        customers.value = await Customer.init().all()
        return customers.value.forEach(customer => {
            return customer.meta['checkbox'] = false
        })
    }
    const findCustomerById = (customer_id) => {
        return customers.value.find(customer => customer.customer_id == customer_id) || {}
    }


    // Fetch single customer
    const customer = ref({})
    const getCustomer = computed(() => customer.value)
    const resetCustomer = () => {
        customer.value = {}
    }
    const model = (customer_id = null) => {
        return new Customer({ customer_id: customer_id })
    }
    const fetchCustomer = async (customer_id = null) => {
        return customer.value = await model(customer_id).get()
    }


    // filter customer
    const filterCustomer = async (search) => {
        console.log('customer search', search)
    }

    const bulkDelete = async (ids) => {
        if (!ids || !ids.length) return Toast.warning('Nothing to delete!')
        let response = await Customer.init().bulkDelete(ids)

        if (response.success) {
            Toast.success(`${ids.length > 1 ? ids.length : ''} ${$settings.labels.customer?.singular}${ids.length > 1 ? 's' : ''} updated successfully`)
            await fetchCustomers()
        }
        else {
            Toast.success(response.message)
        }
    }

    // const generateRandomText = (length) => {
    //     let result = ''
    //     let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
    //     let charactersLength = characters.length

    //     for (let i = 0; i < length; i++) {
    //         result += characters.charAt(Math.floor(Math.random() * charactersLength))
    //     }

    //     return result
    // }

    // onMounted(() => {
    //     console.log('customer mounted')
    //     for (let i = 0; i < 20; i++) {
    //         model().create({
    //             "display_name": "",
    //             "meta": {
    //                 "status": "publish",
    //                 "first_name": generateRandomText(10),
    //                 "last_name": generateRandomText(10),
    //                 "phone": Math.floor(Math.random() * 1000000000),
    //                 "address": generateRandomText(35)
    //             },
    //             "email": `${generateRandomText(5)}.customer@prebook.com`,
    //         })
    //     }
    // })
    // export
    return {
        // isLoading,
        getCustomers,
        fetchCustomers,
        getCustomer,
        resetCustomer,
        fetchCustomer,
        findCustomerById,
        model,

        filterCustomer,
        bulkDelete
    }
})
